import {createFileRoute, Outlet} from '@tanstack/react-router';

import {ImagesCacheProvider} from 'src/contexts/ImagesCacheProvider';

export const Route = createFileRoute('/simsearch')({
  component: SimsearchLayout,
});

function SimsearchLayout() {
  return (
    <ImagesCacheProvider mode='archive'>
      <Outlet />
    </ImagesCacheProvider>
  );
}
